import { useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { Check, CheckCheck } from 'lucide-react'
import { format } from 'date-fns'

const REACTIONS = ['❤️', '😂', '🔥', '👍', '😢', '😮', '🎉']

interface Props {
  msg: any
  isMine: boolean
  showDate: boolean
  onReply: (msg: any) => void
  onReact: (msgId: string, emoji: string) => void
}

export default function MessageBubble({ msg, isMine, showDate, onReply, onReact }: Props) {
  const [showReactions, setShowReactions] = useState(false)

  return (
    <div>
      {showDate && (
        <div className="date-sep">
          <span>{format(new Date(msg.created_at), 'MMMM d, yyyy')}</span>
        </div>
      )}
      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.15 }}
        className={`msg-row ${isMine ? 'mine' : 'theirs'}`}
        onContextMenu={e => { e.preventDefault(); onReply(msg) }}
        onClick={() => setShowReactions(!showReactions)}
      >
        <div className={`bubble ${isMine ? 'mine' : 'theirs'}`}>
          {msg.reply_to && (
            <div className="reply-preview">
              <div className="reply-line" />
              <span>Replying</span>
            </div>
          )}
          <p className="msg-text">{msg.text}</p>
          <div className="msg-meta">
            <span className="msg-time">{format(new Date(msg.created_at), 'h:mm a')}</span>
            {isMine && (
              <span className="msg-tick">
                {msg.status === 'read' ? <CheckCheck size={14} color="#53bdeb" /> : <Check size={14} />}
              </span>
            )}
          </div>
        </div>

        <AnimatePresence>
          {showReactions && (
            <motion.div
              initial={{ opacity: 0, y: 5, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0 }}
              className={`reaction-bar ${isMine ? 'right' : 'left'}`}
            >
              {REACTIONS.map(e => (
                <motion.button key={e} whileTap={{ scale: 1.4 }} className="react-btn" onClick={() => onReact(msg.id, e)}>
                  {e}
                </motion.button>
              ))}
              <button className="react-btn" onClick={() => { onReply(msg); setShowReactions(false) }} style={{ fontSize: 14, color: 'var(--accent)' }}>↩</button>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  )
}
